import type { SkillBook } from '@mezha/api'
import { baseApi } from '../baseApi'

export const skillsApi = baseApi.injectEndpoints({
  endpoints: b => ({
    skills: b.query<SkillBook, void>({ query: () => ({ get: '/api/v1/skills' }), providesTags: ['Skills'] }),
    setSkills: b.mutation<SkillBook, { expected_version: number; slots: string[] }>({
      query: body => ({ command: '/api/v1/skills/set', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(skillsApi.util.upsertQueryData('skills', undefined, data))
        dispatch(baseApi.util.invalidateTags(['Hero']))
      },
    }),
  }),
})

export const { useSkillsQuery, useSetSkillsMutation } = skillsApi
